module.exports = __webpack_public_path__ + "static/media/influence-edition-2025.c70774c3.jpg";